import type { User, UserSettingsLanguage } from '~/api/generated';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as User | null
  }),
  getters: {
    isExternalCompany: (state) => !!state.user?.is_external
  },
  actions: {
    async getUser() {
      const apiStore = useApiStore();

      const user = await apiStore.api.user.userMeRetrieve();

      if (user) {
        this.user = user;
      }
    },

    async updateUser({ requestBody }: { requestBody: UserSettingsLanguage }) {
      const apiStore = useApiStore();

      await apiStore.api.user.userUpdateSettings({ requestBody });

      await this.getUser();
    },

    updatePassword({
      requestBody
    }: {
      requestBody: {
        old_password: string;
        new_password: string;
      };
    }) {
      const apiStore = useApiStore();

      return apiStore.api.user.userChangePassword({ requestBody });
    }
  },
  persist: {
    storage: persistedState.localStorage
  }
});
